export default {
    ua_ua: 'UA',
    ua_avgd2: 'Avg.D2(T-1)',
    ua_spend: 'Spend({unit})',
    ua_avgcpi: 'Avg.CPI({unit})',
    ua_d2t1: 'D2(T-1)',
    ua_cpi: 'CPI({unit})',
    ua_ROAS: 'ROAS',
    ua_avgroas: 'Avg.ROAS',
    ua_engagementTrends: 'Engagement Trends',
    ua_spendMetricsTrends: 'Spend Metrics Trends',

    ua_spend$: 'Spend({unit})',
    ua_cpiTab: 'CPI({unit})',
    ua_cpaTab: 'CPA({unit})',
    ua_roasTab: 'ROAS',
    // charts
    ua_no_spend_chart_Organic: 'Organic',
    ua_no_spend_chart_Others: 'Others',
    ua_no_spend_chart_ua: 'UA',

    ua_Date: 'Date',
    ua_Install: 'Install',
    ua_Register: 'Register',
    ua_Cohort_Register: 'Cohort Register%',
    ua_D2: 'D2',
    ua_D3: 'D3',
    ua_D7: 'D7',
    ua_D14: 'D14',
    ua_D30: 'D30',
    ua_LTV1: 'LTV1',
    ua_LTV3: 'LTV3',
    ua_LTV7: 'LTV7',
    ua_LTV14: 'LTV14',
    ua_LTV30: 'LTV30',
    ua_LTV180: 'LTV180',

    // table
    ua_table_Install: 'Install',
    ua_table_Register: 'Register',
    ua_table_spend: 'Spend({unit})',
    ua_table_cpi: 'CPI({unit})',
    ua_table_cpa: 'CPA({unit})',
    ua_table_ROAS: 'ROAS',
    ua_table_roasd1: 'ROAS-D1',
    ua_table_roasd3: 'ROAS-D3',
    ua_table_roasd7: 'ROAS-D7',

    ua_Overall_Performance: 'Overall Performance',
    ua_Country_Region_Network_TypeBreakdown: 'Country/Region/Network Type Breakdown',
    ua_tab_country: 'Country',
    ua_tab_Region: 'Region',
    ua_tab_Network: 'Network Type',

    ua_Top_Country: 'Register of Top 10 Countries',
    ua_Top_Region: 'Register of Top 10 Regions',
    ua_Top_Network: 'Register of Top 10 Network Type',
    ua_Top_Zone: 'Register of top 10 Zones',

    ua_Ltv7_Top_Country: 'LTV7 of Top 10 Countries',
    ua_Ltv7_Top_Region: 'LTV7 of Top 10 Regions',
    ua_Ltv7_Top_Network: 'LTV7 of Top 10 Network Type',

    ua_CPA_Top_Countries: 'CPA of Top 10 Countries',
    ua_CPA_Top_Region: 'CPA of Top 10 Regions',
    ua_CPA_Top_Network: 'CPA of Top 10 Network Type',

    ua_chart_register: 'Register',
    ua_Sum_Register: 'Sum Register',
    ua_Share_of_ALL: 'Share of All',
    ua_Avg_LTV7: 'Avg.LTV7',
    ua_Avg_CPA: 'Avg.CPA({unit})',
    ua_Sum: 'Sum',
    ua_Register_chart: 'Register',

    ua_install: 'Install',
    ua_register: 'Register',
    ua_d2: 'D2',
    ua_d3: 'D3',
    ua_d7: 'D7',
    ua_roas: 'ROAS',
    ua_ltv_3: 'LTV3',
    ua_cpa: 'CPA({unit})',

    ua_no_auth_message: 'You don\'t authority to view the UA data,Please contact your business UA market colleagues or vegarxu.'
};
